import React from 'react'
import '../Login/Login.css'

import Layout from '../Layout'
import ForgotPasswordFunction from '../../../utils/CommonFunctionality/ForgotPasswordFunction'

const ForgotPassword = () => {
    return (
        <Layout>
            <div className="clearfix row vcaLogin">
                <div className="col-12">
                    <div className="loginFormBox">
                        <ForgotPasswordFunction />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ForgotPassword
